export const ArrowDownRed = ({ ...props }) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.1745 10.1786L8.46017 15.6071C8.18449 15.8694 7.83071 16 7.47635 16C7.12199 16 6.76821 15.8694 6.49253 15.6071L0.778245 10.1786C0.206245 9.63504 0.182817 8.73104 0.726352 8.1585C1.27042 7.58929 2.17557 7.56471 2.74589 8.10714L6.04778 11.2436V1.42857C6.04778 0.6395 6.68728 0 7.47635 0C8.26542 0 8.90492 0.6395 8.90492 1.42857V11.2436L12.2068 8.10714C12.7777 7.56471 13.6828 7.58818 14.2264 8.1585C14.7699 8.73104 14.7464 9.63504 14.1745 10.1786Z"
        fill="#FF3541"
      />
    </svg>
  )
}
